import { render, staticRenderFns } from "./exccAuthForm.vue?vue&type=template&id=40d43942&scoped=true&"
import script from "./exccAuthForm.vue?vue&type=script&lang=js&"
export * from "./exccAuthForm.vue?vue&type=script&lang=js&"
import style0 from "./exccAuthForm.vue?vue&type=style&index=0&id=40d43942&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d43942",
  null
  
)

export default component.exports